import React from "react";
import Story from "../../layouts/Story";
import SideBySideMap from "./charts/SideBySideMap";
import MobilityChart from "./charts/MobilityChart";
import Limitations from "./charts/Limitations";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const StoryFour = () => {
  const additionalComponents = {
    sideBySideMap: SideBySideMap,
    mobilityChart: (props) => (
      <MobilityChart
        {...props}
        jakartaEvents={copy.jakartaEvents}
        wealthLabels={copy.wealthLabels}
        months={copy.months}
      />
    ),
    limitations: Limitations,
  };

  return <Story {...copy} additionalComponents={additionalComponents} />;
};

export default StoryFour;
